<template lang="pug">
  .gw-headline.gw-headline_loaded
    #headerStyle(v-html="getHeaderTheme")
    .gw-headline__container
      .gw-headline__wrapper

        MyGamesHeadlineLogo(v-if="!hideLogo")

        MyGamesHeadlineNavigation(v-if="show_navigation", :links="navigation_links")

        .gw-headline__right
          MyGamesHeadlineLanguages(v-if="show_languages", :promoName="promoName", :showFullLanguages="showFullLanguages")
          MyGamesHeadlineUser(:userLinks="userLinks")
</template>

<script>
// For dropdowns - https://www.npmjs.com/package/vue-click-outside
import MyGamesHeadlineLogo from "./blocks/MyGamesHeadlineLogo";
import MyGamesHeadlineNavigation from "./blocks/MyGamesHeadlineNavigation";
import MyGamesHeadlineLanguages from "./blocks/MyGamesHeadlineLanguages";
import MyGamesHeadlineUser from "./blocks/MyGamesHeadlineUser";

import env from "../../libs/tools/Environment";

export default {
  name: "MyGamesHeadline",

  components: {
    MyGamesHeadlineLogo,
    MyGamesHeadlineNavigation,
    MyGamesHeadlineLanguages,
    MyGamesHeadlineUser,
  },

  props: {
    userLinks: {
      type: Array,
      required: true,
    },
    headerBGColor: {
      type: String,
      required: false,
    },
    headerTextColor: {
      type: String,
      required: false,
    },
    promoName: {
      type: String,
      required: false,
    },
    showFullLanguages: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideNavigation: {
      type: Boolean,
      default: false,
    },
    hideLogo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show_navigation: false,
      show_languages: false,
      navigation_links: null,
    };
  },

  computed: {
    getHeaderTheme() {
      return `
        <style>
          .gw-headline {
            --gw-headline-background-color: ${this.headerBGColor ? this.headerBGColor : "#000"};
            --gw-headline-text-color: ${this.headerTextColor ? this.headerTextColor : "#fff"};
          }
        </style>
      `;
    },
  },

  created() {
    if (window.__GEM) {
      this.showNavigation();
    } else {
      document.addEventListener("GEM_loaded", () => {
        this.showNavigation();
      });
    }

    this.show_languages = env.isMyGames();
  },

  methods: {
    showNavigation() {
      if (!this.hideNavigation) {
        this.navigation_links = window.__GEM.getCrossLinks();
        this.show_navigation = env.isMyGames();
      }
    },
  },
};
</script>

<style lang="stylus">
.gw-headline
  font-family: 'Roboto', Arial, Helvetica, Helvetica Neue, sans-serif;
  position: relative
  z-index: 1000
  background: var(--gw-headline-background-color, #000)
  width: 100%
  font-size: 14px
  line-height: 37px
  height: 37px
  color: var(--gw-headline-text-color, #fff)
  -webkit-font-smoothing: antialiased

  & a
    text-decoration none
    color inherit
    transition all .1s
    opacity .5
    cursor pointer

    &:hover
      opacity .8

.gw-headline__container
  margin: 0 auto
  width: 100%
  padding-left: 30px
  padding-right: 30px

.gw-headline__wrapper
  display flex
  justify-content flex-end

.gw-headline__logo
  padding-right 10px

  & a
    display: flex
    align-items center
    height 100%

.gw-headline__menu
  width 100%
  display flex
  align-items center
  justify-content flex-start
  @media (max-width: 860px)
    display none

.gw-headline__item
  padding 0 10px
  white-space nowrap

.gw-headline__right
  display flex

.gw-headline__dropdown
  position: relative

  &-default
    position: relative
    padding-right: 13px
    white-space: nowrap
    cursor: pointer
    opacity: .5
    transition: all .1s

    &:hover
      opacity .8

    &:after
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      margin-top: -6px;
      width: 12px;
      height: 12px;
      background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjQiIHZpZXdCb3g9IjAgMCA4IDQiPgogICAgPHBhdGggZmlsbD0iI0Y1RjVGNyIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiNGNUY1RjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTcgLjY4M0wzLjk4IDQgMSAuNjgzIDEuNC4yNWwyLjU4IDIuODcxTDYuNi4yNXoiIC8+Cjwvc3ZnPgo=") no-repeat center;
      transition: transform .1s;

  &-list
    position: absolute
    z-index: 100
    top: 100%
    left: 0
    margin-top: -5px
    padding: 4px 0
    background-color: var(--gw-headline-background-color, #000)
    border-radius: 4px

  &-item
    display: block
    padding: 10px 20px
    line-height: normal
    white-space: nowrap
    cursor: pointer
    opacity: .8

    &:hover
      opacity: 1
      background-color: rgba(#fff, .08)

  &-item,
  &-item:link,
  &-item:hover,
  &-item:active,
  &-item:focus,
  &-item:visited
    color: var(--gw-headline-text-color, #fff)

.gw-headline__dropdown_opened .gw-headline__dropdown-default
  opacity .8

  &:after
    transform: rotate(180deg);

.ph-headline__dropdown_right .ph-headline__dropdown-list,
.ph-headline__langs .ph-headline__dropdown-list
  left auto
  right 0
</style>
